/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cognito_identity_pool_id": "ap-south-1:84beec44-e5a1-4ace-9032-712c75b4ca24",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_1Oxad5nET",
    "aws_user_pools_web_client_id": "37gli81sev9egoieh7laf6f0v5",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "collabhousfiles173731-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1"
};


export default awsmobile;
